<template>
    <div>
        <x-navigation ref="navigation"></x-navigation>
        <v-main v-if="user_loaded">
            <router-view />
        </v-main>
    </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState({
            user_loaded : (state) => state.userData.user_loaded,
        }),
    },
}
</script>
